module.exports = __webpack_public_path__ + "media/images/top/contents_s_bg-e1bee79ac94d8e6a219b900cb2bcb9c8.gif";